import React from 'react';
import { FieldTemplateProps } from '@rjsf/utils';
import { CustomArrayField } from './CustomArrayField';

interface CustomObjectTemplateProps {
  schema: any;
  formData: { [key: string]: any } | undefined;
  onChange: (value: any) => void;
  disabled?: boolean;
  readonly?: boolean;
}

const CustomObjectTemplate: React.FC<CustomObjectTemplateProps> = ({
  schema,
  formData,
  onChange,
  disabled,
  readonly,
}) => {
  const locked = !!(disabled || readonly);
  let obj: { [key: string]: any } = schema.properties as { [key: string]: any };

  const handleFieldChange = (key: string, value: any) => {
    if (formData) {
      onChange({ ...formData, [key]: value });
    }
  };

  const renderAttributes = () => {
    return Object.keys(obj).map((key) => {
      return (
        <div key={key} className="flex flex-col">
          {/* <label className='text-body-sm font-bold'>{obj[key].title}</label> */}
          {/* <label>OBJECT {obj[key].type}</label> */}
          {obj[key].type === 'array' ? (
            <div className="ml-3 flex flex-col">
              <CustomArrayField
                schema={obj[key]}
                formData={formData ? formData[key] : undefined}
                onChange={(value: any) => handleFieldChange(key, value)}
                disabled={locked}
              />
            </div>
          ) : (
            <div className="ml-3 flex flex-col">
              <label>{obj[key].title}</label>
              <input
                className="my-2 rounded rounded-sm border border-ui-field-outline p-1.5 px-2"
                value={formData ? formData[key] : ''}
                onChange={(e) => handleFieldChange(key, e.target.value)}
                disabled={locked}
              />
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div>
      {schema.title}
      {renderAttributes()}
    </div>
  );
};

export default CustomObjectTemplate;
